/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/passkey_medium'
export default icon
